<div 
  *ngIf="!env.production"
  [className]="'env-indicator ' + env.environment">
  {{ env.environment }}
</div>
<router-outlet></router-outlet>
